var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade-slide"}},[(_vm.visible)?_c('div',_vm._g({class:_vm.classes,attrs:{"data-test-id":"dropdown"}},_vm.$listeners),[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }